// extracted by mini-css-extract-plugin
module.exports = {"btnDark":"Button_btnDark__9NQM-","btnLight":"Button_btnLight__2VTPk"};